import { Pagination, Sort } from "services/search";

export type TableSize = "auto" | "small" | "medium" | "large" | "full";

export interface TableProps {
  data: any[];
  columns: Column[];
  selectableRows?: boolean;
  selectedRows?: number[];
  disablePagination?: boolean;
  pagination?: Pagination;
  onPaginationChange?: (pagination: Pagination) => void;
  disableSelection?: boolean;
  showSelectAll?: boolean;
  onSelectedChange?: (selected: number[] | number) => void;
  onRowClick?(id: string): void;
  onEventClick?(id: string, name: string): void;
  isLoading?: boolean;
  isMinimized?: boolean;
  columnsChild?: Column[];
  CustomTableRowChild?: React.ComponentType<TableRowChildProps>;
  childTableTitle?: string;
  size?: TableSize;
  /** Dodatne klase po retku — npr. isticanje redaka koji traže pažnju. */
  rowClassName?: (row: any) => string;
}

export interface TableHeaderProps {
  columnProperties: ColumnProperty[];
  selectableItems: boolean;
  rowCount: number;
  numSelected: number;
  onSelectAllClick(event: React.ChangeEvent<HTMLInputElement>): void;
  disableSelection?: boolean;
  showSelectAll?: boolean;
  onSort?: (sort: Sort) => void;
  sort?: Sort;
  isChildTable?: boolean;
  columnToggle?: React.ReactNode;
}

export interface TableBodyProps {
  rowClassName?: (row: any) => string;
  data: any[];
  columns: Column[];
  selectedRows: number[];
  selectableRows?: boolean;
  onRowClick?(id: string): void;
  onEventClick?(id: string, name: string): void;
  onSelectCheckboxClick?(id: number): void;
  disableSelection?: boolean;
  columnsChild?: Column[];
  CustomTableRowChild?: React.ComponentType<TableRowChildProps>;
  childTableTitle?: string;
}

export interface TableRowProps {
  rowClassName?: (row: any) => string;
  columns: Column[];
  row: any;
  selectedRows: number[];
  selectableRows?: boolean;
  onRowClick?(id: string): void;
  onEventClick?(id: string, name: string): void;
  onSelectCheckboxClick?(id: number): void;
  disableSelection?: boolean;
  columnsChild?: Column[];
  CustomTableRowChild?: React.ComponentType<TableRowChildProps>;
  childTableTitle?: string;
}

export interface TableRowChildProps {
  index: number;
  row: any;
  onRowClick?(id: string): void;
  onFetchSearchResult?: () => void;
}

export interface CustomTableRowChildProps {
  columns: Column[];
  rows: any;
  show: boolean;
  onRowClick?(id: string): void;
  onEventClick?(id: string, name: string): void;
  CustomTableRowChild?: React.ComponentType<TableRowChildProps>;
  parentColumnsCount: number;
  childTableTitle?: string;
}




export type Column =
  | StringColumn
  | ImageColumn
  | BooleanColumn
  | ButtonColumn
  | CustomColumn
  | RenderByRow;

export enum ColumnTypes {
  string = "string",
  image = "image",
  boolean = "boolean",
  button = "button",
  custom = "custom",
  renderByCustomRow = "renderedByCustomRow",
}

interface ColumnBase {
  title: string;
  sortable?: boolean;
  searchable?: boolean;
  field?: string;
  key?: string;
  alwaysVisible?: boolean;
  defaultVisible?: boolean;
  tooltip?: string;
}

interface StringColumn extends ColumnBase {
  type: ColumnTypes.string;
  field: string;
}

interface ImageColumn extends ColumnBase {
  type: ColumnTypes.image;
  field: string;
}

interface BooleanColumn extends ColumnBase {
  type: ColumnTypes.boolean;
  field: string;
}

interface ButtonColumn extends ColumnBase {
  type: ColumnTypes.button;
  buttonConfig: ButtonConfig;
}

interface CustomColumn extends ColumnBase {
  type: ColumnTypes.custom;
  render(row: any, onEventClick: any): any;
}

interface RenderByRow extends ColumnBase {
  type: ColumnTypes.renderByCustomRow;
  meta?: any;
}

interface ButtonConfig {
  text: string;
  action: (row: any) => void;
}

export interface ColumnProperty {
  title: string;
  sortable: boolean;
  field: string;
  tooltip?: string;
}

export interface TableFooterProps<T = any, D = any> {
  columnCount: number;
  footerData?: T;
  onFooterAction?: D;
  pagination?: Pagination;
  onPaginationChange?: (pagination: Pagination) => void;
  isMinimized?: boolean;
}

export interface TablePaginationProps {
  pagination?: Pagination;
  onChangePage: any;
  rowsSizeOptions: number[];
  onChangeRowsSize: any;
  isMinimized?: boolean;
}

export interface SortControlProps {
  rowsSizeOptions: number[];
  onChangeRowsSize: any;
  width?: "min" | "small" | "medium" | "large" | "full";
}

export interface PaginationControlProps {
  pagination?: Pagination;
  onChangePage: any;
}

export interface PaginationDisplayControlProps {
  pagination: Pagination;
}
